import { render } from "./account-top-dropdown.component.vue?vue&type=template&id=079b9b03&ts=true"
import script from "./account-top-dropdown.component.vue?vue&type=script&lang=ts"
export * from "./account-top-dropdown.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__